import type { IntlShape } from "react-intl";

import type { SelectOption } from "components/v2/Select/types";
import { getServiceTranslations } from "helpers/translationHelpers/serviceTranslations";

export const DEFAULT_SERVICE_TYPE = "dtd";

type ServiceTypeOptionSource = {
  label: string;
  value: string;
};

export function normalizeServiceTypeOptions(
  options: ServiceTypeOptionSource[] | Record<string, ServiceTypeOptionSource> | undefined,
  intl: IntlShape,
): SelectOption[] {
  if (!options) return [];

  const optionList = Array.isArray(options) ? options : Object.values(options);

  return optionList.map((item) => ({
    label: getServiceTranslations(item.label, intl),
    value: item.value?.toLowerCase() ?? "",
  }));
}

export function resolveDefaultServiceType(
  options: SelectOption[],
  currentValue?: string | null,
): string | null {
  if (!options.length) return null;

  // Cleared by the user — do not re-apply a default (e.g. after accordion remount on Review).
  if (currentValue === null || currentValue === "") {
    return null;
  }

  const normalizedCurrent = currentValue?.toLowerCase();
  const matchingOption = options.find((option) => option.value === normalizedCurrent);
  if (matchingOption) return matchingOption.value;

  const defaultOption =
    options.find((option) => option.value === DEFAULT_SERVICE_TYPE) ?? options[0];

  return defaultOption?.value ?? null;
}
